import { createAsyncThunk } from '@reduxjs/toolkit'
import { makeFetchSlice, fetchHomeDataThunk } from 'app/redux-fetch'
import {
  migrateSubscription,
  renewSubscription,
  UpdateSubscriptionParams,
} from 'features/home/api'
import { RENEW_SUBSCRIPTION_REDUCER_NAME } from 'features/home/consts'
import { fetchHomeThunk } from 'features/home/slice'
import { fetchSubscriptionsThunk } from '../slice'

export const migrateSubscriptionSlice = makeFetchSlice('migrateSubscription')

export const migrateSubscriptionReducer = migrateSubscriptionSlice.reducer
export const migrateSubscriptionActions = migrateSubscriptionSlice.actions

export const migrateSubscriptionThunk = createAsyncThunk<
  any,
  UpdateSubscriptionParams
>('subscription/migrate', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await fetchHomeDataThunk({
      dispatch,
      actions: migrateSubscriptionActions,
      asyncFunc: () => migrateSubscription(params),
    })

    await dispatch(fetchSubscriptionsThunk(params.homeId))
    await dispatch(fetchHomeThunk(params.homeId))

    return response
  } catch (error: any) {
    if (error?.response) {
      throw rejectWithValue(error?.response.data)
    }
    console.log('Error migrating subscription', error)
    throw error
  }
})

const renewSubscriptionSlice = makeFetchSlice(RENEW_SUBSCRIPTION_REDUCER_NAME)

export const renewSubscriptionReducer = renewSubscriptionSlice.reducer
export const renewSubscriptionActions = renewSubscriptionSlice.actions

export const renewSubscriptionThunk = createAsyncThunk<
  any,
  UpdateSubscriptionParams
>('subscription/renew', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await fetchHomeDataThunk({
      dispatch,
      actions: renewSubscriptionActions,
      asyncFunc: () => renewSubscription(params),
    })

    await dispatch(fetchSubscriptionsThunk(params.homeId))
    await dispatch(fetchHomeThunk(params.homeId))

    return response
  } catch (error: any) {
    if (error?.response) {
      throw rejectWithValue(error?.response.data)
    }
    console.log('Error renew subscription', error)
    throw error
  }
})
